import { useLayoutEffect, useRef, useState } from 'react';
import {
  navMenuList,
  navMenuListScrollIndicator,
  scrollIndicator,
} from './navMenu.css';
import { NavMenuSection, NavMenuSectionProps } from './NavMenuSection';
import { Typography } from '../typography/typography';
import { useBreakpoints } from '@design-system/breakpointsStore';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown } from '@fortawesome/pro-regular-svg-icons';

export type NavMenuListProps = {
  list: NavMenuSectionProps[];
};

export const NavMenuListRaw = (p: NavMenuListProps) => (
  <div className={navMenuList} role="list">
    {p.list.map((s) => (
      <NavMenuSection key={s.section} {...s} />
    ))}
  </div>
);

export const ScrollIndicator = () => {
  const isTablet = useBreakpoints((s) => s.tablet);

  return (
    <div className={scrollIndicator}>
      <Typography variant="body" size="small" color="W-100">
        {isTablet ? (
          <FontAwesomeIcon icon={faChevronDown} />
        ) : (
          'scroll for more'
        )}
      </Typography>
    </div>
  );
};

export const NavMenuList = (p: NavMenuListProps) => {
  const ref = useRef<HTMLDivElement | null>(null);
  const [showScrollIndicator, setShowScrollIndicator] = useState(true);
  const breakpoint = useBreakpoints((s) => s.breakpoint);

  useLayoutEffect(() => {
    const element = ref.current.firstChild as HTMLDivElement;

    const handleScroll = () => {
      const spacing = 20;
      const isBottom =
        element.scrollHeight - element.scrollTop - spacing <=
        element.clientHeight;
      const show = !isBottom && element.clientHeight < element.scrollHeight;
      setShowScrollIndicator(show);
    };
    handleScroll();
    element.addEventListener('scroll', handleScroll, { passive: true });
    return () => element.removeEventListener('scroll', handleScroll);
  }, [breakpoint]);

  return (
    <div ref={ref} className={navMenuListScrollIndicator}>
      <NavMenuListRaw {...p} />
      {showScrollIndicator && <ScrollIndicator />}
    </div>
  );
};
